/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const ChevronDown: React.FC = (): JSX.Element => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.33317 1.3335L3.99984 4.66683L0.666504 1.3335"
      stroke="#B8C2CC"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
